export const hostStyles = [
    {
        personality: 'cheerleader',
        label: 'Cheerleader',
        labelDescription: 'Sweet & supportive',
        voiceActor: 'Charon', // Google: Informative. Alternatives: Achird (Friendly)
        gender: 'male',
        disabled: false,
    },
    {
        personality: 'cheerleader',
        label: 'Cheerleader',
        labelDescription: 'Sweet & supportive',
        voiceActor: 'Leda', // Google: Youthful. Alternatives: Vindemiatrix (Gentle), Sulafat (Warm)
        gender: 'female',
        disabled: false,
    },
    {
        personality: 'comedian',
        label: 'Comedian',
        labelDescription: 'Snarky & witty',
        voiceActor: 'Orus', // Google: Firm. Alternatives: Kore (Firm), Alnilam (Firm)
        gender: 'male',
        disabled: false,
    },
    {
        personality: 'comedian',
        label: 'Comedian',
        labelDescription: 'Snarky & witty',
        voiceActor: 'Kore', // Google: Firm. Alternatives: Orus (Firm), Alnilam (Firm)
        gender: 'female',
        disabled: false,
    },
    {
        personality: 'diva',
        label: 'Diva',
        labelDescription: 'Dramatic & intense',
        voiceActor: 'Puck', // Google: Upbeat. Alternatives: Rasalgethi (Informative), Schedar (Even)
        gender: 'male',
        disabled: false,
    },
    {
        personality: 'diva',
        label: 'Diva',
        labelDescription: 'Dramatic & intense',
        voiceActor: 'Zephyr', // Google: Bright. Alternatives: Pulcherrima (Forward), Autonoe (Bright)
        gender: 'female',
        disabled: false,
    },
    {
        personality: 'entertainer',
        label: 'Entertainer',
        labelDescription: 'Quirky & whimsical',
        voiceActor: 'Fenrir', // Google: Excitable. Alternatives: Sadachbia (Lively)
        gender: 'male',
        disabled: false,
    },
    {
        personality: 'entertainer',
        label: 'Entertainer',
        labelDescription: 'Quirky & whimsical',
        voiceActor: 'Aoede', // Google: Breezy. Alternatives: Callirrhoe (Easy-going)
        gender: 'female',
        disabled: false,
    },
    {
        personality: 'slacker',
        label: 'Slacker',
        labelDescription: 'Bored & unbothered',
        voiceActor: 'Sadachbia', // Google: Lively (mismatch for Slacker). Alternatives: Umbriel (Easy-going), Zubenelgenubi (Casual)
        gender: 'male',
        disabled: false,
    },
    {
        personality: 'slacker',
        label: 'Slacker',
        labelDescription: 'Bored & unbothered',
        voiceActor: 'Sulafat', // Google: Warm (mismatch for Slacker). Alternatives: Callirrhoe (Easy-going)
        gender: 'female',
        disabled: false,
    },
    {
        personality: 'villain',
        label: 'Villain',
        labelDescription: 'Menacing & mischievous',
        voiceActor: 'Algenib', // Google: Gravelly. Alternatives: Rasalgethi (Informative)
        gender: 'male',
        disabled: false,
    },
    {
        personality: 'villain',
        label: 'Villain',
        labelDescription: 'Menacing & mischievous',
        voiceActor: 'Vindemiatrix', // Google: Gentle (mismatch for Villain). Alternatives: Pulcherrima (Forward), Gacrux (Mature)
        gender: 'female',
        disabled: false,
    },
];
//# sourceMappingURL=hostStyles.js.map